import { FC } from 'react';

import { useGetDeviceCaptionsSettings, useSetLocation, useUserSettings } from '@hooks';

export const UserSettingsSetup: FC = () => {
  useSetLocation();
  useUserSettings();
  useGetDeviceCaptionsSettings();

  return null;
};
